'use client';
import classNames from 'classnames';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import { useUser } from '@/forApp/states/userState/userState';
import Button from '@/shared/Buttons/Button';
import BaseLink from '@/shared/Links/BaseLink';
import Logo from '@/shared/Logo/Logo';
import { ROUTES } from '@/forApp/utils/routes';

import styles from './styles.module.css';

const SecondLineHeader = () => {
  const { user } = useUser();
  const { addModal } = useApp();
  const clientPathname = usePathname();

  useEffect(() => {}, [clientPathname]);

  const router = useRouter();

  const onOpen = () => {
    if (user) router.push(ROUTES.ADD);
    else addModal({ name: 'AuthModal', type: 'login' });
  };

  const isHome = clientPathname === '/';
  const textColor = isHome ? 'white' : 'black';
  return (
    <div
      className={classNames(
        styles.secondHeadWrap,
        !isHome ? styles.secondHeadWrapLight : '',
      )}
    >
      <div className={classNames(styles.secondHeadContent, 'container')}>
        <div className={styles.logoWrp}>
          <Logo color={textColor} />
        </div>
        <div className={styles.linkWrp}>
          <BaseLink
            href={'/apartments/'}
            text={'Квартиры'}
            color={textColor}
            type={'header'}
          />
          <BaseLink
            href={'/new-buildings/'}
            text={'Новостройки'}
            color={textColor}
            type={'header'}
          />
          <BaseLink
            href={'/houses/'}
            text={'Дома и участки'}
            color={textColor}
            type={'header'}
          />
          <BaseLink
            href={'/garages/'}
            text={'Гаражи'}
            color={textColor}
            type={'header'}
          />
          <BaseLink
            href={'/retail-spaces/'}
            text={'Коммерческая'}
            color={textColor}
            type={'header'}
          />
        </div>
        <div className={styles.btnWrp}>
          <Button
            text={'Разместить объявление'}
            color={isHome ? 'white' : 'dark'}
            onClick={onOpen}
          />
        </div>
      </div>
    </div>
  );
};

export default SecondLineHeader;
